<template>
  <div class="mycoupon-box">
    <van-sticky>
      <van-tabs v-model:active="active" sticky type="card" @click-tab="goOther">
        <van-tab title="未使用"></van-tab>
        <van-tab title="已使用"></van-tab>
        <van-tab title="已过期"></van-tab>
        <van-tab title="已删除"></van-tab>
      </van-tabs>
    </van-sticky>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component"></component>
      </keep-alive>
    </router-view>

    <van-popup
      v-model:show="state.showTips"
      position="bottom"
      round
      :style="{ height: 'auto', background: 'none' }"
    >
      <div class="splitTips">
        <h3>可拆分优惠券</h3>
        <div>
          可拆分优惠券是特殊优惠券道具，可在游戏充值时进行使用：
          <p>1.游戏充值时可消耗优惠券余额进行抵扣；</p>
          <p>2.不可与其他优惠券叠加使用；</p>
          <p>
            3.在游戏中使用时，无门槛限制，任意充值金额都可以使用，直到余额扣完为止；
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reactive, ref, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import bus from "@/utils/bus";

import { useStore } from "vuex";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";

export default {
  name: "mycoupon",
  setup() {
    const store = useStore();
    const active = ref(0);
    const router = useRouter();
    const state = reactive({
      // username:''
      uid: getQueryString("uid"),
      // uid:'7888'

      showTips: false,
    });

    onBeforeMount(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
        store.dispatch("getInfo");
      }
    });
    //全局van-nav-bar添加渐变灰颜色
    // 返回
    const onClickLeft = () => {
      router.back();
      window.webkit.messageHandlers.JsBridge.postMessage("ClickBack://");
    };

    const goOther = ({ title }) => {
      console.log(title);
      if (title == "未使用") {
        router.replace({
          path: "/newcoupon/mycoupon/newnotexpired",
          query: { uid: state.uid },
        });
      } else if (title == "已使用") {
        router.replace({
          path: "/newcoupon/mycoupon/newexpired",
          query: { uid: state.uid },
        });
      } else if (title == "已过期") {
        router.replace({
          path: "/newcoupon/mycoupon/newtimeExpired",
          query: { uid: state.uid },
        });
      } else if (title == "已删除") {
        router.replace({
          path: "/newcoupon/mycoupon/newdeleted",
          query: { uid: state.uid },
        });
      }
    };

    bus.on("splitShow", function() {
      // state.splitShow = false
      state.showTips = true;
      console.log("splitShow");
    });

    return {
      active,
      state,
      onClickLeft,
      goOther,
    };
  },
};
</script>

<style>
.van-tabs__wrap {
  padding-top: 30px;
  padding-bottom: 10px;
  background-color: #f7f8fa;
  /* tab 放不下时可横向滑动 */
  overflow-x: auto;
  flex-wrap: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  /* color: #fff;
  border-radius: 50%;
   */
}

:deep(.van-tabs__nav--card)::-webkit-scrollbar {
  display: none;
}

.van-tabs__nav--card {
  border: none;
  color: #f7f8fa;
  border-radius: 50%;
}

.van-tab {
  color: #999 !important;
  border-radius: 100px;
  border-right: none !important;
  background-color: #fff;
  flex-shrink: 0;
  margin: 0 12px;
  /* margin-right: 58px; */
}


.van-tabs__nav {
  background-color: #f7f8fa;
}

.van-tabs__nav--card .van-tab--active {
  color: #fff !important;
  background: linear-gradient(270deg, #0ea6a0 0%, #12cec7 100%) !important;
}

.van-sticky {
  background-color: #fff;
}
.splitTips {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 150px;
  font-size: 38px;
}
.splitTips h3 {
  color: #12cec7;
}
.splitTips div {
  margin-top: 20px;
  font-size: 28px;
  padding: 0 32px;
}
.splitTips div p {
  margin-top: 10px;
}
</style>
